<template>
  <tr class="is-clickable is-next" @click="onShowClick">
    <td class="c-table__cell--left c-table__cell--middle c-table__cell--no-padding" colspan="2">
      <div class="c-cell">
        <p class="date u-w140">{{ deliverDate }}</p>
        <p class="title u-w400 u-text-ellipsis">{{ scenario.scenario_name }}</p>
      </div>
    </td>
    <td class="c-table__cell--center c-table__cell--middle">{{ stepCount }}</td>
    <td class="c-table__cell--right c-table__cell--middle">{{ displayCount }}</td>
    <td class="c-table__cell--right c-table__cell--middle">{{ clickCount }}</td>
    <td class="c-table__cell--right c-table__cell--middle">{{ clickRate }}</td>
  </tr>
</template>

<script>
export default {
  props: {
    scenario: Object,
    stepInfo: Object,
  },
  emits: ["show-click"],
  computed: {
    message: function () {
      let message = null;
      if (this.scenario && this.scenario.scenario_messages.length > 0) {
        message = this.scenario.scenario_messages[0].message;
      }
      return message;
    },
    deliverDate: function () {
      let deliverDate = '';
      let message = this.message;
      if (message && message.message_deliver) {
        deliverDate = this.getDisplayDate(message.message_deliver.send_start_date);
      }
      return deliverDate;
    },
    displayCount: function() {
      let displayCount = 0;
      let message = this.message;
      if(message && message.summary_message_dailies){
        message.summary_message_dailies.forEach(summaryMessageDaily => {
          displayCount += parseInt(summaryMessageDaily.display_count);
        });
      }
      return displayCount.toLocaleString();
    },
    clickCount: function() {
      let clickCount = 0;
      let message = this.message;
      if(message && message.summary_message_dailies){
        message.summary_message_dailies.forEach(summaryMessageDaily => {
          clickCount += parseInt(summaryMessageDaily.click_count);
        });
      }
      return clickCount.toLocaleString();
    },
    stepCount: function () {
      // シナリオに含まれる総ステップ数
      return this.scenario && this.scenario.scenario_messages
        ? this.scenario.scenario_messages.length
        : 0;
    },
    clickRate: function () {
      // 初回ステップ (Step1) の集計でクリック率を算出する。
      // displayCount/clickCount と同じ message ソースから直接計算する（toLocaleString 適用前の値が必要なため）。
      let message = this.message;
      if (!message || !message.summary_message_dailies) return '0.00';
      let display = 0;
      let click = 0;
      message.summary_message_dailies.forEach(d => {
        display += parseInt(d.display_count);
        click += parseInt(d.click_count);
      });
      if (display <= 0) return '0.00';
      return (click / display * 100).toFixed(2);
    },
  },
  mounted: function() {
  },
  methods: {
    onShowClick: function () {
      this.$emit('show-click', this.scenario.scenario_id);
    },
  },
};
</script>

<style scoped>
tr.is-clickable {
    cursor: pointer;
}
tr.is-clickable:hover {
    background-color: #f5f9fc;
}
</style>
